<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  import './app.less'
  export default {
    name: 'app'
  }
</script>
